import fragmentPriceRangeFields from '~/modules/GraphQL/customQueries/fragments/fragmentPriceRangeFields';
import fragmentProductFields from '~/modules/GraphQL/customQueries/fragments/fragmentProductFields';
import fragmentProductAdditionalFields from '~/modules/GraphQL/customQueries/fragments/fragmentProductAdditionalFields';

export default `
  #graphql
  query getProductPriceBySku(
    $filter: ProductAttributeFilterInput,
    $configurations: [ID!]
  ) {
    products(filter: $filter) {
      items {
        ...ProductFields
        price_range {
          ...PriceRangeFields
        }

        ... on ConfigurableProduct {
          price_range {
            ...PriceRangeFields
          }

          configurable_product_options_selection(configurableOptionValueUids: $configurations) {
            options_available_for_selection {
              attribute_code
              option_value_uids
            }
            media_gallery {
              disabled
              label
              position
              url
            }
            variant {
              ...ProductFields
              ...ProductAdditionalFields
              price_range {
                ...PriceRangeFields
              }
            }
          }
        }

        ... on BundleProduct {
          dynamic_sku
          items {
            position
            __typename
            required
            sku
            title
            type
            uid
            options {
                uid
                quantity
                position
                is_default
                price
                price_type
                can_change_quantity
                label
                product {
                  bestseller
                  recommended
                  categories {
                    id
                    name
                    level
                  }
                  id
                  manufacturer
                  name
                  new_from_date
                  new_to_date
                  price_range {
                    ...PriceRangeFields
                  }
                  productAttachments {
                    file
                    title
                    type
                    url
                  }
                  short_description {
                    html
                    __typename
                  }
                  sku
                  stock_item {
                    max_sale_qty
                    min_sale_qty
                    qty_increments
                  }
                  stock_status
                  thumbnail {
                    disabled
                    label
                    position
                    url
                  }
                  uid
                }
              }
          }
        }
      }
    }
  }
  ${fragmentPriceRangeFields}
  ${fragmentProductFields}
  ${fragmentProductAdditionalFields}
`;
